export const checksums = {
  "header": "v3.5.0--TNmpEZErNWu6K4O0aXjTH4WPy5lC7asZlpnDOw2SMxU",
  "footer": "v3.5.0--Mx_sNLqjvwTABZlgMQhsEOZqAfyIJzsqMVZ1WPI8M_I",
  "config": "v3.5.0--xN01PKmYlG2zznlTYhnM_cYQY65lB94LTFb6iVAQbj4",
  "introduction": "v3.5.0--nJ9yQgHzVeSkKsDZ9wUacarL1lCWNT6WU7ayOKw4Vbc",
  "pricing": "v3.5.0--95GhraHNRGuTaD-GNm8ltWGWUX5xCiN31X0xjHlJCT0",
  "features": "v3.5.0--WG8LhyICwjXFQxUaJjwy9DvTgxhSGFb_2VDMBxuySsU",
  "resources": "v3.5.0--BqiJxsarY53AqIpXCPkMqz4CVMlTo23U7zSB-eVguuM",
  "docs": "v3.5.0--EsKZjPMEsku8vs64ZapYp5yDEWzxsOn7cUN8NGiXq64"
}
export const checksumsStructure = {
  "header": "0ZrQ1HFcGzORoOjIYMvAuOolpyEU7kz4Qdljp6EL6g4",
  "footer": "y3q2ex3URr4r4QkLUrRo9d9HXF0s13ZmVfb059t96KM",
  "config": "teIctwVCzzkBqQLtTaXYKWZZ88gu-9zrFlnkksVVKbg",
  "introduction": "yFXNoIqJlznsW_n7f4lvtTQWJ5E3O9Dmcasa94k7jQA",
  "pricing": "NWC8LgUDCHOR383cgLDkYtTBFc4h0vpVxoZLgJuWqyY",
  "features": "2Pq013zD0adDsLkPJkP-6dceZVUw_xtZ70dLTbQaeVo",
  "resources": "XCS6suXux0H73xybIkzJFFotXxbN2TQABa3NPsCx3aM",
  "docs": "k081xqUFk3AN5ZOmP0l1e7zpoYoQzlgBkPm6mc5iawk"
}

export const tables = {
  "header": "_content_header",
  "footer": "_content_footer",
  "config": "_content_config",
  "introduction": "_content_introduction",
  "pricing": "_content_pricing",
  "features": "_content_features",
  "resources": "_content_resources",
  "docs": "_content_docs",
  "info": "_content_info"
}

export default {
  "header": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "app": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "features": "string",
      "login": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "pricing": "string",
      "resources": "string",
      "seo": "json",
      "signup": "string",
      "stem": "string"
    }
  },
  "footer": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "copyRight": "string",
      "description": "string",
      "extension": "string",
      "formLink": "json",
      "importantLinks": "json",
      "meta": "json",
      "moreInfo": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "config": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "langs": "json",
      "logo": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "introduction": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "features": "json",
      "hero": "json",
      "lang": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "quote": "json",
      "seo": "json",
      "stem": "string",
      "trustedBy": "json",
      "video": "json"
    }
  },
  "pricing": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "hero": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "prices": "json",
      "seo": "json",
      "stem": "string",
      "why": "json"
    }
  },
  "features": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "carroussel": "json",
      "description": "string",
      "extension": "string",
      "faq": "json",
      "featureList": "json",
      "hero": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "resources": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "categories": "json",
      "description": "string",
      "extension": "string",
      "heroSubtitle": "string",
      "heroTitle": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "placeholder": "string",
      "quickLinks": "json",
      "seo": "json",
      "stem": "string"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "description": "string",
      "extension": "string",
      "language": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "type": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}